import { useCurrentURL } from "../hooks/ContextualNavigations";
import { buildAccessContext } from "./buildAccessContext";
import { AccessContext } from "./types";

// Monta o AccessContext a partir do host do window e dos params de acesso (useCurrentURL).
// Fonte única lida pela resolução de marca e pela seleção de variante (useScreenVariant),
// e também por Login/index.tsx. Move de código: não altera a resolução existente.
export function useAccessContext(): AccessContext {
  const params = useCurrentURL();
  return buildAccessContext({
    host: window.location.hostname,
    params: { url: params.url, rules: params.rules },
  });
}
